define('InternalLinkView',['backbone', 'jquery', 'router', 'site_vars'], function (Backbone, $, router, site_vars) {
    //
    // Lien interne
    //

    var InternalLinkView = Backbone.View.extend({
        events: {
            'click': 'go', 'tap': 'go'
        }, initialize:function(){
            this.el.internalLinked = true;
        },
        route: function () {
            var routeRegExp = new RegExp('(' + router.getBaseUrl() + ')(.*)'),
                route = routeRegExp.exec(this.el.href)[2];
            return route==''?'/':route;

        }, go: function (event) {
            event.preventDefault();
            router.go(this.route() || '')
        },
        remove:function(){
            delete this.el.internalLinked;
            Backbone.View.prototype.remove.apply(this);
        }
    });


    //
    // Static method
    // Permet d'initializer les liens d'un context jQuery
    // retourne un tableau de InternalLinkView
    //
    InternalLinkView.initializeLinks = function(jqueryContext){
        if(site_vars.ignore_routing) return [];
        var links = [];
        jqueryContext.not('.ignore-routing').each(function(){
            // si le lien est déjà linké, on ne créé pas de nouvelle vue
            if(this.internalLinked === true) return;
            links.push(new InternalLinkView({el:this}));
        });
        return links;
    };

    // 
    // Static method
    // permet d'initialiser tous les liens d'une vue
    //
    InternalLinkView.initializeLinksOfView = function(view){
        var links = InternalLinkView.initializeLinks(view.$('a[href^="'+router.getBaseUrl()+'"], a[href^="/"]'));
        view.attachViews(links);
        return links;
    };

    //
    // Static method
    // permet d'initialiser tous les liens d'un élement HTML
    //
    InternalLinkView.initializeLinksOfEl = function(el){
        return InternalLinkView.initializeLinks($('a[href^="'+router.getBaseUrl()+'"], a[href^="/"]',el))
    };
    
    return InternalLinkView;
});
